import { localStorageKeyPrefix } from '@previo/core'

enum LocalStorageKeys {
  AUTHORIZATION = 'authorization',
  CHUNK_LOAD_RELOAD = 'chunk_load_reload',
  USER = 'user',
}

class LocalStorageKeyManager {
  private static prefix = localStorageKeyPrefix()

  static createStorageKey(key: LocalStorageKeys): string {
    return this.prefix + key
  }
}

export { LocalStorageKeys, LocalStorageKeyManager }
